// The resulting type will have the common properties between T and U required and the ones that exist in just one of them will be optional
export type CommonProperties<T, U> = {
  [K in keyof T & keyof U]: T[K];
} & {
  [K in Exclude<keyof T, keyof U>]?: T[K];
} & {
  [K in Exclude<keyof U, keyof T>]?: U[K];
};

export enum BottomPadding {
  Small = 'Small',
  Large = 'Large',
  None = 'None',
}

export enum IconPosition {
  Left = 'left',
  Right = 'right',
}
